module.exports = __webpack_public_path__ + "static/media/image 16.eaf96e9c.png";